module.exports = __webpack_public_path__ + "img/error.23acbc4b.svg";